module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-left-down-6bf00e8ca48cfd38dde43d540ad91ccb.svg";